import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sendNowField", "datetimeInput", "submitButton"];

  updateSendNow() {
    if (this.datetimeInputTarget.value) {
      this.sendNowFieldTarget.value = "no";
      this.updateButtonText(this.submitButtonTarget.dataset.scheduledSendScheduledTextValue);
    } else {
      this.sendNowFieldTarget.value = "yes";
      this.updateButtonText(this.submitButtonTarget.dataset.scheduledSendSendNowTextValue);
    }
  }

  updateButtonText(text) {
    if (this.hasSubmitButtonTarget && text) {
      this.submitButtonTarget.textContent = text;
    }
  }
}

